import { Button, Card } from "antd";
import styled from "styled-components";

export const StyledGalleryUploader = styled.div`
    width: 100%;
    display: flex;
    gap: 12px;
`;

export const StyledPhotosContainer = styled.div<{ $hasPhotos: boolean }>`
    overflow-x: auto;
    min-width: ${({ $hasPhotos }) => ($hasPhotos ? "80px" : "0px")};
    width: auto;
    max-width: calc(100% - 92px);
    flex-shrink: 1;
`;

export const StyledPhotoCard = styled(Card)`
    flex-shrink: 0;
    width: 80px;
    height: 80px;
    overflow: hidden;
    position: relative;

    .ant-card-body {
        padding: 0;
    }

    .ant-card-cover {
        height: 100%;
        width: 100%;
    }
`;

export const StyledPhotoPreview = styled.div`
    height: 80px;
    overflow: hidden;

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const StyledPhotoList = styled.div`
    display: flex;
    gap: 16px;
    min-width: min-content;
    width: 100%;
`;

export const StyledUploader = styled.div`
    height: 80px;
    min-width: 80px;
    flex-grow: 1;
    flex-shrink: 0;

    .ant-upload,
    .ant-btn {
        width: 100% !important;
        height: 100% !important;
        background: ${({ theme }) => theme.itemBackground};
        border-radius: 10px !important;

        svg {
            font-size: 24px;
            transition: color 0.2s ease;
        }

        &:hover {
            svg {
                color: ${({ theme }) => theme.additionalTypographyColor};
            }
        }
    }

    .ant-upload-wrapper {
        width: 100% !important;
        height: 100% !important;
    }

    .ant-upload-select-picture-card {
        &:hover {
            border-color: ${({ theme }) => theme.additionalTypographyColor};
        }
    }
`;

export const StyledPreviewImage = styled.img`
    display: block;
    width: 100%;
    max-height: 100%;
    object-fit: contain;
`;

export const StyledModalFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
`;

export const StyledButton = styled(Button)`
    border: none;
    width: 24px !important;
    height: 24px;

    svg {
        font-size: 22px;
    }
`;

export const StyledDeleteButton = styled(StyledButton)`
    color: ${({ theme }) => theme.dangerTypographyColor};
`;

export const StyledModalControllers = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    left: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
`;
